import React from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://rdec.com.br";
export const SITE_NAME = "Restart Design & Consulting";
const DEFAULT_OG_IMAGE = `${SITE_URL}/logos/RDEC-BLUE.png`;

interface SeoProps {
  title: string;
  description: string;
  /** Path absoluto da rota, ex: "/portfolio". Usado no canonical e og:url. */
  path: string;
  image?: string;
  noindex?: boolean;
  /** Objetos JSON-LD (schema.org) injetados como <script type="application/ld+json"> */
  jsonLd?: object | object[];
}

const Seo: React.FC<SeoProps> = ({
  title,
  description,
  path,
  image = DEFAULT_OG_IMAGE,
  noindex = false,
  jsonLd,
}) => {
  const url = `${SITE_URL}${path}`;
  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <html lang="pt-BR" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="pt_BR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLdArray.map((schema, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

/** Schema LocalBusiness/Organization da RDEC — usado na home */
export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#organization`,
  name: "Restart Design & Consulting Ltda.",
  alternateName: "RDEC",
  url: SITE_URL,
  logo: DEFAULT_OG_IMAGE,
  image: DEFAULT_OG_IMAGE,
  email: "contact@rdec.com.br",
  description:
    "Fornecimento de soluções em automação industrial para o setor de Óleo & Gás: válvulas industriais, atuadores pneumáticos, sensores de monitoramento, conexões para tubulação e serviços especializados.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Avenida Estrela do Mar, 59, Praia de Guanabara",
    addressLocality: "Anchieta",
    addressRegion: "ES",
    addressCountry: "BR",
  },
  areaServed: "BR",
};

export default Seo;
